import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);
  if (loading) {
    return <div data-section-id="47369" className="hidden lg:flex gap-10 animate-pulse">
      {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-20 bg-muted/30 rounded" />)}
    </div>;
  }
  return <>
      {}
      <div className="hidden lg:block">
        <NavigationMenu viewport={false}>
          <NavigationMenuList className="gap-10 space-x-0">
            {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                <NavigationMenuLink asChild>
                  <Link to={item.href || "#"} className="relative font-sans text-[13px] uppercase tracking-widest text-primary transition-colors hover:text-primary/70 py-2 block group">
                    {item.label}
                    <span className="absolute bottom-0 left-1/2 h-[1px] w-0 -translate-x-1/2 bg-primary transition-all duration-500 ease-out group-hover:w-full" />
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>
      </div>

      {}
      <div className="lg:hidden">
        <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(true)} className="hover:bg-transparent text-primary" aria-label="Open menu">
          <Menu className="h-6 w-6" />
        </Button>
      </div>

      {}
      {isMobileMenuOpen && <div className="fixed inset-0 z-50 flex flex-col bg-background/98 backdrop-blur-2xl animate-in fade-in slide-in-from-right-10 duration-500">
          <div className="flex items-center justify-between px-6 py-5 border-b border-border/30">
            <span className="font-sans text-sm font-bold tracking-[0.3em] text-primary">MENU</span>
            <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(false)} className="hover:bg-transparent text-primary" aria-label="Close menu">
              <X className="h-6 w-6" />
            </Button>
          </div>
          <div className="flex-1 overflow-y-auto py-12 px-8">
            <nav className="flex flex-col gap-8">
              {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="font-sans text-3xl uppercase tracking-widest text-primary hover:text-primary/60 transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                  {item.label}
                </Link>)}
            </nav>
          </div>
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <header id="header" className={`sticky top-0 left-0 right-0 z-40 w-full transition-all duration-500 ease-in-out ${isScrolled ? "bg-background/80 backdrop-blur-md border-b border-border/40 py-4 shadow-sm" : "bg-background border-b border-transparent py-7"}`}>
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between">
        {}
        <Link to="/TheCarefulConsultingPage" className="flex-shrink-0 z-50">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/pixelforge_logo.png" alt="The Careful Consulting" className="h-8 w-auto object-contain brightness-[0.2] contrast-125" />
        </Link>

        {}
        <MenuProvider menu_id="47">
          <HeaderNavigation />
        </MenuProvider>
      </div>
    </header>;
}